module.exports = __webpack_public_path__ + "img/T5-B-rc5.bc931022.png";